export default __webpack_public_path__ + "static/media/Mow.20d01719.jpg";